import {
    Box,
    Button,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid,
    IconButton,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField,
    Typography,
    useMediaQuery
} from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import CloseIcon from '@mui/icons-material/Close';
import React, { Fragment, useEffect, useState } from 'react';
import ReactPlayer from 'react-player';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import Layout from '../../components/Layout';
import { useAppDispatch, useAppSelector } from '../../redux';
import { AppDispatch } from '../../redux/store';
import { Question, useAddBreefForm } from '../../utils/forms';
import { getAllBreefs, getTeamsByBreefId, updateBreefAdmin } from '../../service/BreefService';
import { useTranslation } from 'react-i18next';


const UpdateViewBreef = () => {
    const [t] = useTranslation("global");
    const [, setIsView] = useState(false)
    const [isDelete, setIsDelete] = useState(false);
    const dispatch: AppDispatch = useAppDispatch();

    const data = useAppSelector((state => state.breefs.breefData.results));
    const navigate = useNavigate();
    const { breefId }:any = useParams();
    const query = new URLSearchParams(useLocation().search);
    const isEdit = query.get('isEdit');
    const [isEditing, setIsEditing] = useState<Boolean>(isEdit === 'true'? true : false);
    const isMobile = useMediaQuery('(max-width:600px)');
    const formik = useAddBreefForm(breefId || '', isMobile);

    const [teams, setTeams] = useState<any[]>([]);
    const [isTeamsLoading, setIsTeamsLoading] = useState<boolean>(false);
    const [selectedTeam, setSelectedTeam] = useState<any>(null);
    const [isUsersModalOpen, setIsUsersModalOpen] = useState<boolean>(false);

    function handleCancel(): void {
        setIsEditing(false)
        setIsView(false)
        handleGoBack();
    }
    const handleGoBack = async () => {
        navigate(-1)
    }
    useEffect(() => {
        if (isDelete) {
            setIsDelete(false)
        }
        getAllBreefs(dispatch, isMobile, navigate);
    }, [formik.isSubmitting, isDelete])

    const fetchTeams = async () => {
        if (!breefId) return;
        setIsTeamsLoading(true);
        try {
            const teamData = await getTeamsByBreefId(breefId, isMobile, navigate);
            if (Array.isArray(teamData)) {
                setTeams(teamData);
            }
        } catch (err) {
            console.error("Error fetching breef teams:", err);
        } finally {
            setIsTeamsLoading(false);
        }
    };

    useEffect(() => {
        fetchTeams();
    }, [breefId]);

    const handleTeamClick = (team: any) => {
        setSelectedTeam(team);
        setIsUsersModalOpen(true);
    };

    const handleCloseUsersModal = () => {
        setIsUsersModalOpen(false);
        setSelectedTeam(null);
    };

    const handleSubmit = async(e: React.FormEvent<HTMLFormElement>) => {
        console.log("Entered here", formik.values);
        
        e.preventDefault();
        await updateBreefAdmin(breefId, formik.values);
        // formik.handleSubmit(e as any);
        setIsEditing(false)
        setIsView(false);
    };
    const setUpBreef = () => {
        if (!data || data.length === 0) return;
        const breef = data.filter((breef) => breef.id === breefId)
        if (!breef || breef.length === 0) return;
        const mappedQuestions = breef[0].questions?.map((question: any) => {
            return {
                question: question.question,
                options: question.options,
                answer: question.answer
            };
        }) || [];
        formik.setValues({
            period:breef[0].period,
            expiry:breef[0].expiry,
            breefName: breef[0].breefName,
            gameId: typeof breef[0].gameId === 'string' ? breef[0].gameId : (breef[0].gameId?.id || ''),
            questions: mappedQuestions,
            status: breef[0].status,
            tenantId: typeof breef[0].tenantId === 'string' ? breef[0].tenantId : (breef[0].tenantId?.id || ''),
            videoUrl: breef[0].videoUrl,
            gameName: breef[0].gameId?.gameName || '',
            tenantName: breef[0].tenantId ? (breef[0].tenantId.firstName + " " + breef[0].tenantId.lastName) : ''
        });
    }
    useEffect(() => {
        setUpBreef();
    }, [breefId, isEdit, data])
    useEffect(() => {
        console.log("is edit ", isEdit)
    }, [])
    return (
        <Layout>
            <div style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'flex-start',
                marginRight: '10%',
                marginTop: '2%',
                marginBottom: '1%'
            }}>
                <Button onClick={handleCancel} variant="outlined" sx={{ minWidth: '1%', marginLeft: '1%' }}>
                    {'<'}
                </Button>
                <Typography variant="h4" fontWeight="bold" style={{ marginLeft: '6%' }}>{isEdit === 'true' ? 'Update' : 'View'} Breef </Typography>
                </div>
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    marginX: '10%',
                    marginBottom: '5%',
                    // justifyContent: 'flex-start',
                    // backgroundColor: 'blue'
                }}
            >
                <Box component="form" onSubmit={handleSubmit}>
                    <Grid container spacing={2}>
                        <Grid item xs={6} sm={4}>
                            <TextField
                                autoFocus
                                required
                                fullWidth
                                id="breefName"
                                name="breefName"
                                label="Breef Name"
                                type="text"
                                variant="outlined"
                                onChange={formik.handleChange("breefName")}
                                value={formik.values.breefName}
                                error={formik.touched.breefName && Boolean(formik.errors.breefName)}
                                helperText={formik.touched.breefName && formik.errors.breefName}
                                disabled={isEdit === 'true' ? false : true}
                            />
                            
                        </Grid>
                        <Grid item xs={6} sm={4}>
                            <TextField
                                autoFocus
                                required
                                fullWidth
                                id="breefName"
                                name="period"
                                label="Start Date"
                                type="text"
                                variant="outlined"
                                onChange={formik.handleChange("breefName")}
                                value={formik.values.period}
                                error={formik.touched.breefName && Boolean(formik.errors.breefName)}
                                helperText={formik.touched.breefName && formik.errors.breefName}
                                disabled={ true}
                            />
                            
                        </Grid>
                        <Grid item xs={6} sm={4}>
                            <TextField
                                autoFocus
                                required
                                fullWidth
                                id="breefName"
                                name="expiry"
                                label="End Date"
                                type="text"
                                variant="outlined"
                                onChange={formik.handleChange("breefName")}
                                value={formik.values.expiry}
                                error={formik.touched.breefName && Boolean(formik.errors.breefName)}
                                helperText={formik.touched.breefName && formik.errors.breefName}
                                disabled={true}
                            />
                            
                        </Grid>
                        <Grid item  style={{ display: 'flex', justifyContent: 'start', alignItems: 'start', width: '100%' }}>
                            <ReactPlayer
                                url={formik.values.videoUrl}
                                width={'100%'}
                                playing={true}
                                loop={true}
                                controls={true}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                fullWidth
                                id="tenantName"
                                name="tenantName"
                                label="Tenant Name"
                                type="text"
                                variant="outlined"
                                onChange={formik.handleChange("tenantName")}
                                value={formik.values.tenantName}
                                error={formik.touched.tenantName && Boolean(formik.errors.tenantName)}
                                helperText={formik.touched.tenantName && formik.errors.tenantName}
                                disabled={true}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                required
                                fullWidth
                                id="gameName"
                                name="gameName"
                                label="Game Name"
                                type="text"
                                variant="outlined"
                                onChange={formik.handleChange("gameName")}
                                value={formik.values.gameName}
                                disabled={true}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                required
                                fullWidth
                                id="status"
                                name="status"
                                label="Status"
                                type="text"
                                variant="outlined"
                                onChange={formik.handleChange("status")}
                                value={formik.values.status}
                                error={formik.touched.status && Boolean(formik.errors.status)}
                                helperText={formik.touched.status && formik.errors.status}
                                disabled={isEdit === 'true' ? false : true}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>

                        </Grid>
                        {formik.values.questions.map((question: Question, index: number) => (
                            <Fragment key={index}>
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        required
                                        fullWidth
                                        id={`question-${index}`}
                                        name={`question-${index}`}
                                        label={`Question ${index + 1}`}
                                        type="text"
                                        variant="outlined"
                                        onChange={formik.handleChange(`questions[${index}].question`)}
                                        value={formik.values.questions[index].question}
                                        disabled={isEdit === 'true' ? false : true}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    {question.options.map((option, optionIndex: number) => (
                                        <TextField
                                            key={optionIndex}
                                            required
                                            fullWidth
                                            id={`question-${index}-option-${optionIndex}`}
                                            name={`question-${index}-option-${optionIndex}`}
                                            label={formik?.values?.questions[index].options[optionIndex]===String(formik.values.questions[index].answer) ? "Right Answer":"Wrong Answer"}
                                            type="text"
                                            variant="outlined"
                                            onChange={formik.handleChange(`questions[${index}].options[${optionIndex}]`)}
                                            value={formik.values.questions[index].options[optionIndex]}
                                            sx={{ marginBottom: 2 }}
                                            disabled={isEdit === 'true' ? false : true}
                                        />
                                    ))}
                                    <TextField
                                        required
                                        fullWidth
                                        id={`question-${index}-answer`}
                                        name={`question-${index}-answer`}
                                        label="Answer"
                                        type="text"
                                        variant="outlined"
                                        onChange={formik.handleChange(`questions[${index}].answer`)}
                                        value={formik.values.questions[index].answer}
                                        disabled={isEdit === 'true' ? false : true}
                                    />
                                </Grid>
                            </Fragment>
                        ))}
                    </Grid>

                    <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end' }}>
                        {
                            isEditing ?
                                (
                                    <>
                                        <Button sx={{color: '#ED670A', mr:1, borderColor: '#ED670A', '&:hover': {borderColor: '#ED670A'}}} onClick={handleCancel} variant="outlined">
                                        {t('updatebreef.t1')}
                                        </Button>
                                        <Button sx={{backgroundColor: '#ED670A', '&:hover': {backgroundColor: '#d55a07'}}} type="submit" variant="contained">
                                        {t('updatebreef.t2')}
                                        </Button>
                                    </>
                                )
                                :
                                (
                                    <>
                                    </>
                                )
                        }
                    </Box>
                </Box>

                <Box sx={{ width: '100%', mt: 5 }}>
                    <Typography variant="h5" fontWeight="bold" sx={{ mb: 2 }}>
                        Assigned Teams
                    </Typography>
                    {isTeamsLoading ? (
                        <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}>
                            <CircularProgress sx={{ color: '#ED670A' }} />
                        </Box>
                    ) : teams && teams.length > 0 ? (
                        <TableContainer component={Paper} sx={{ borderRadius: 2, boxShadow: 2 }}>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell sx={{ backgroundColor: '#ED670A', color: '#fff', fontWeight: 'bold' }}>
                                            Team Name
                                        </TableCell>
                                        <TableCell sx={{ backgroundColor: '#ED670A', color: '#fff', fontWeight: 'bold' }} align="center">
                                            Number of Members
                                        </TableCell>
                                        <TableCell sx={{ backgroundColor: '#ED670A', color: '#fff', fontWeight: 'bold' }} align="center">
                                            Actions
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {teams.map((team: any) => (
                                        <TableRow
                                            key={team.id || team._id}
                                            hover
                                            sx={{ cursor: 'pointer' }}
                                            onClick={() => handleTeamClick(team)}
                                        >
                                            <TableCell sx={{ fontWeight: 500 }}>
                                                {team.teamName}
                                            </TableCell>
                                            <TableCell align="center">
                                                {team.members !== undefined ? team.members : (team.membersName ? team.membersName.length : 0)}
                                            </TableCell>
                                            <TableCell align="center">
                                                <Button
                                                    size="small"
                                                    variant="outlined"
                                                    startIcon={<VisibilityIcon />}
                                                    sx={{
                                                        color: '#ED670A',
                                                        borderColor: '#ED670A',
                                                        '&:hover': { borderColor: '#d55a07', backgroundColor: 'rgba(237, 103, 10, 0.04)' }
                                                    }}
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        handleTeamClick(team);
                                                    }}
                                                >
                                                    View Users
                                                </Button>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    ) : (
                        <Paper sx={{ p: 3, textAlign: 'center', backgroundColor: '#f9f9f9', borderRadius: 2 }}>
                            <Typography variant="body1" color="text.secondary">
                                No teams assigned to this breef.
                            </Typography>
                        </Paper>
                    )}
                </Box>

                <Dialog
                    open={isUsersModalOpen}
                    onClose={handleCloseUsersModal}
                    maxWidth="md"
                    fullWidth
                >
                    <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', backgroundColor: '#ED670A', color: '#fff' }}>
                        <Typography variant="h6" fontWeight="bold">
                            {selectedTeam ? `Users in Team: ${selectedTeam.teamName}` : 'Team Members'}
                        </Typography>
                        <IconButton onClick={handleCloseUsersModal} sx={{ color: '#fff' }}>
                            <CloseIcon />
                        </IconButton>
                    </DialogTitle>
                    <DialogContent sx={{ mt: 2 }}>
                        {selectedTeam?.membersName && selectedTeam.membersName.length > 0 ? (
                            <TableContainer component={Paper} sx={{ maxHeight: 400 }}>
                                <Table stickyHeader>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f5f5f5' }}>#</TableCell>
                                            <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f5f5f5' }}>First Name</TableCell>
                                            <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f5f5f5' }}>Last Name</TableCell>
                                            <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f5f5f5' }}>Email</TableCell>
                                            <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f5f5f5' }}>Phone Number</TableCell>
                                            <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f5f5f5' }} align="center">Total Score</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {selectedTeam.membersName.map((user: any, idx: number) => (
                                            <TableRow key={user._id || user.id || idx} hover>
                                                <TableCell>{idx + 1}</TableCell>
                                                <TableCell>{user.firstName || '-'}</TableCell>
                                                <TableCell>{user.lastName || '-'}</TableCell>
                                                <TableCell>{user.email || '-'}</TableCell>
                                                <TableCell>{user.phoneNumber || '-'}</TableCell>
                                                <TableCell align="center">{user.totalScore !== undefined ? user.totalScore : '0'}</TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        ) : (
                            <Box sx={{ p: 3, textAlign: 'center' }}>
                                <Typography variant="body1" color="text.secondary">
                                    No users found in this team.
                                </Typography>
                            </Box>
                        )}
                    </DialogContent>
                    <DialogActions sx={{ p: 2 }}>
                        <Button onClick={handleCloseUsersModal} variant="outlined" sx={{ color: '#ED670A', borderColor: '#ED670A' }}>
                            Close
                        </Button>
                    </DialogActions>
                </Dialog>
            </Box>
        </Layout>
    )
}

export default UpdateViewBreef